import type { RootState } from '@store';

export const guestSelector = (state: RootState) => state.guest;
